import { Modal } from 'react-bootstrap';
import type { FunctionComponent } from 'react';
import { AuthGoogleStepBody, AuthGoogleStepButtons } from './AuthGoogleStep';

type Props = {
  isOpen: boolean;
  onHide: () => void;
};

export const ClaimDomainModal: FunctionComponent<Props> = ({ isOpen, onHide }) => {
  return (
    <Modal show={isOpen} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Claim New Domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AuthGoogleStepBody />
      </Modal.Body>
      <Modal.Footer>
        <AuthGoogleStepButtons />
      </Modal.Footer>
    </Modal>
  );
};

export default ClaimDomainModal;
